const InsightMessage = ({ message, values = {} }) => {
  const parts = message.split(/(\*\*.*?\*\*|\{[^}]+\})/g)

  return (
    <span>
      {parts.map((part, index) => {
        const highlightMatch = part.match(/^\*\*(.*?)\*\*$/)

        if (highlightMatch) {
          const content = highlightMatch[1]
          const value = content.replace(/\{([^}]+)\}/g, (_, key) => values[key] ?? "")

          return (
            <strong key={index} className="text-orange-600 font-bold">
              {value}
            </strong>
          )
        }

        const value = part.replace(/\{([^}]+)\}/g, (_, key) => values[key] ?? "")

        return <span key={index}>{value}</span>
      })}
    </span>
  )
}

export default InsightMessage
